import emailjs from "@emailjs/browser";

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const TEMPLATE_ID_CONTACT = import.meta.env.VITE_EMAILJS_TEMPLATE_ID_CONTACT;
const TEMPLATE_ID_QUOTE = import.meta.env.VITE_EMAILJS_TEMPLATE_ID_QUOTE;
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
const EMAIL_TO = import.meta.env.VITE_EMAIL_TO;

function getMissingVars(): string[] {
  const missing: string[] = [];
  if (!SERVICE_ID) missing.push("VITE_EMAILJS_SERVICE_ID");
  if (!PUBLIC_KEY) missing.push("VITE_EMAILJS_PUBLIC_KEY");
  if (!EMAIL_TO) missing.push("VITE_EMAIL_TO");
  return missing;
}

export function isEmailJSConfigured(): boolean {
  return Boolean(SERVICE_ID && PUBLIC_KEY && EMAIL_TO);
}

export function getEmailTo(): string {
  return EMAIL_TO || "";
}

export function getConfigError(): string | null {
  const missing = getMissingVars();
  if (missing.length > 0) {
    return `Missing: ${missing.join(", ")}. Add them to your .env file.`;
  }
  return null;
}

export async function sendContactEmail(
  params: Record<string, unknown>
): Promise<void> {
  const missing = getMissingVars();
  if (missing.length > 0) {
    throw new Error(`Missing: ${missing.join(", ")}`);
  }
  if (!TEMPLATE_ID_CONTACT) {
    throw new Error("Missing: VITE_EMAILJS_TEMPLATE_ID_CONTACT");
  }
  await emailjs.send(SERVICE_ID!, TEMPLATE_ID_CONTACT, params, {
    publicKey: PUBLIC_KEY!,
  });
}

export async function sendQuoteEmail(
  params: Record<string, unknown>
): Promise<void> {
  const missing = getMissingVars();
  if (missing.length > 0) {
    throw new Error(`Missing: ${missing.join(", ")}`);
  }
  // If no quote template is set, fall back to contact template
  const templateId = TEMPLATE_ID_QUOTE || TEMPLATE_ID_CONTACT;
  if (!templateId) {
    throw new Error("Missing: VITE_EMAILJS_TEMPLATE_ID_CONTACT (used as fallback)");
  }
  await emailjs.send(SERVICE_ID!, templateId, params, {
    publicKey: PUBLIC_KEY!,
  });
}